// extracted by mini-css-extract-plugin
export var discountItem = "discount-benefit-list-module--discount-item--99010";
export var discountList = "discount-benefit-list-module--discount-list--d8a94";